import { PreguntaDTO } from "@DTOS";
import { Exporter } from "../Exporter";

import "@extensiones";

export class ExporterMatriz implements Exporter {
    public puedeExportar(pregunta: PreguntaDTO): boolean {
        return pregunta.esMatriz();
    }

    public exportar(respuestas: any, respuesta: any[], pregunta: PreguntaDTO): void {
        if (pregunta.preguntas == null) {
            return;
        }

        const preguntaDTOMatriz = pregunta.preguntas.find(preguntaMatriz =>
            preguntaMatriz.items.some(itemDTO => itemDTO.id === respuesta[0]));

        if (preguntaDTOMatriz == null) {
            return;
        }

        const itemDTOMatriz = preguntaDTOMatriz.items.find(itemDTO => itemDTO.id === respuesta[0]);

        if (itemDTOMatriz == null) {
            return;
        }

        if (respuestas[pregunta.texto]) {
            respuestas[pregunta.texto] +=
                `, ${preguntaDTOMatriz.texto.sacarCaracteresEdicion()}: ${itemDTOMatriz.texto}`;
            return;
        }

        respuestas[pregunta.texto] = `${preguntaDTOMatriz.texto.sacarCaracteresEdicion()}: ${itemDTOMatriz.texto}`;
    }
}
